import { EmbedMetadata } from '@modules/url-metadata/EmbedMetadata';
import { createEmbedExtension } from '../shared/createEmbedExtension';

export default createEmbedExtension({
  regexp: [
    /(https?:\/\/(?!(?:localhost:8080|dev\.copera\.ai|app\.copera\.ai))[^\s]+)/g,
  ],
  name: 'link-metadata-embed',
  component: EmbedMetadata,
  addCommandOption: {
    title: 'Bookmark',
    description: 'Bookmark a link',
    searchTerms: ['bookmark', 'link'],
    icon: 'tabler:compass',
  },
});
